import { crudRequest, crudRequestGet } from './api';
import { resolve } from 'path';

export const getAccess = () => {
  let access = sessionStorage.getItem('access');
  if (process.env.NODE_ENV !== 'production') {
    // access = access ? JSON.parse(access) : {};
    // access.siteTypeCode = '143';   // 模拟分拨权限
    // access.siteCode = '5712000';
    // access.siteId = '4071';
    // access.siteName = '萧山分拨中心';
    // return access
  }
  return access ? JSON.parse(access) : '';
};

/**  返回省区code,原本返回ID */
export function getProvinceId() {
  const access = getAccess();
  if (process.env.NODE_ENV !== 'production') {
    // return 1666111; // 模拟省区权限
  }
  if (access.siteCode === '999999' || access.siteCode === '999995') {
    return '';
  }
  let provinceId = access?.permissions
    ?.find((item) => item.includes('/auth/provinceAreaTx/'))
    ?.split('/auth/provinceAreaTx/')[1];
  if (provinceId) console.log('营运区ID', provinceId);
  if (access.siteTypeCode === '900800') {
    provinceId = access.siteCode;
  }
  return provinceId;
}

/**
 * 返回配置的所有省区code
 * @returns {String[]}
 */
export function getProvinceIds() {
  const access = getAccess();
  if (process.env.NODE_ENV !== 'production') {
    // return 1666111; // 模拟省区权限
  }
  if (access.siteCode === '999999' || access.siteCode === '999995') {
    return '';
  }
  let provinceIds = access?.permissions
    ?.filter((item) => item.includes('/auth/provinceAreaTx/'))
    .map((item) => item?.split('/auth/provinceAreaTx/')[1]);
  if (access.siteTypeCode === '900800') {
    provinceIds.push(access.siteCode);
    provinceIds = [...new Set(provinceIds)];
  }
  return provinceIds;
}

/** 获取省区权限
 *
 * @returns 省区Code Name 是否省区
 */
export async function GetProvinceAreaAuth() {
  let provinceId = getProvinceId();
  if (provinceId) {
    const data = await getOperatingAreaData(provinceId);
    if (data && data.length > 0) {
      const obj = data.find((item) => item.code === String(provinceId));
      return {
        isArea: true,
        ...obj,
      };
    }
  }
  return null;
}

/** 获取组织架构权限
 *
 */
export async function GetOrganizationAuth() {
  const access = getAccess();
  // 是否是总部
  const isHead = access.siteCode === '999999' || access.siteCode === '999995';
  if (isHead) {
    return {
      isHead: true,
      isArea: false,
      isCenter: false,
    };
  }

  // 是否是省区
  let provinceIds = getProvinceIds();
  if (provinceIds && Array.isArray(provinceIds)) {
    // const data = await getOperatingAreaData(provinceId);
    let results = await Promise.all(provinceIds?.map((id) => getOperatingAreaData(id)));
    results = results.flat();
    if (results && results.length > 0) {
      // const obj = data.find((item) => item.code === String(provinceId));
      console.log('results', results);
      return {
        isHead: false,
        isArea: true,
        isCenter: false,
        ...results?.[0],
        provinces: results?.map((item) => ({ ...item, label: item.name, value: item.code })),
      };
    }
  }

  // 分拨
  const center = { code: access.siteCode, name: access.siteName };
  return {
    isHead: false,
    isArea: false,
    isCenter: true,
    ...center,
  };
}

/**
 * 是否是省区
 */
export async function isAreaData(code) {
  if (!code) {
    return false;
  }
  let results = await getOperatingAreaData(code);
  results = results.flat();
  if (results && results.length > 0) {
    // const obj = data.find((item) => item.code === String(provinceId));
    return true;
  }
  return false;
}

// /**
//  * 是否是分拨
//  * @returns
//  */
// export async function isCenterData(code) {
//   let results = await getOperatingAreaChildCenter(code);
//   results = results.flat();
//   if (results && results.length > 0) {
//     // const obj = data.find((item) => item.code === String(provinceId));
//     console.log('CenterData', results);
//     return true;
//   }
//   return false;

// }

/**
 *  初始化组织架构权限
 */
export function InitOrganizationAuth() {
  const access = getAccess();

  // 是否是总部
  const isHead = access.siteCode === '999999' || access.siteCode === '999995';
  if (isHead) {
    return {
      isHead: true,
      isArea: false,
      isCenter: false,
      code: '',
    };
  }

  // 是否是省区
  let provinceId = getProvinceId();
  if (provinceId) {
    const obj = { code: provinceId };
    return {
      isHead: false,
      isArea: true,
      isCenter: false,
      ...obj,
    };
  }

  // 分拨
  const center = { code: access.siteCode, name: access.siteName };
  return {
    isHead: false,
    isArea: false,
    isCenter: true,
    ...center,
  };
}

/** 根据省区CODE(原本为ID),模糊查询省区下分拨 */
export async function getProvinceChrldCenter(provinceId, keyword = '') {
  const data = await crudRequest(
    '/api/micro/other/station/base/selectCenterListByKey',
    {
      provinceAreaCode: provinceId,
      siteTypeId: '61, 62',
      keyword: keyword,
      limit: 10,
    },
    { reqType: null, module: 'mdp-micro-other-station' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
  return [];
}

/** 获取所有分拨 */
export async function getCenterData() {
  const data = await crudRequest(
    '/api/micro/other/station/selectOrganizationListByTypeCode',
    { typeCode: 'billCenter' },
    { reqType: null, module: 'mdp-micro-other-station' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
  return [];
}

/** 获取所有分拨_天象（provinceAreaCode：营运区 code，接口仅支持单值过滤；多营运区由调用方拆分请求） */
export async function getCenterData_max({ keyword, provinceAreaCode }) {
  const data = await crudRequest(
    '/api/station/keyword/selectByKey',
    {
      keyword,
      limit: 10,
      siteTypeCode: [900100, 900200],
      ...(provinceAreaCode ? { provinceAreaCode } : {}),
    },
    { reqType: null, module: 'mdp-station-keyword' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
  return [];
}

/**
 * 获取所有省区
 * @returns 返回 省区name 省区id 省区code
 */
export async function getProvinceAreaData() {
  const data = await crudRequest(
    '/api/micro/other/station/selectOrganizationListByTypeCode',
    { typeCode: 'provinceArea' },
    { reqType: null, module: 'mdp-micro-other-station' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
  return [];
}

/**
 * 获取所有省区
 * @returns 返回 省区name 省区id(返回结果中code实际为id)
 */
export async function GetProvinceArea() {
  const data = await crudRequest(`/api/micro/district/selectProvinceAreaDict`, null, {
    method: 'POST',
    reqType: 'json',
    module: 'mdp-micro-district',
  });
  if (data && data.code === 1) {
    return data.data;
  }
  return [];
}

export function isHavePermissions(permissItem) {
  const permissions = JSON.parse(sessionStorage.getItem('permissions'));
  return !!permissions?.find((permissItems) => permissItems === permissItem);
}

/**
 * 通过营运区 code 获取对应信息
 * @return 返回完整营运区信息
 */
export async function getOperatingAreaData(value) {
  const data = await crudRequest(
    '/api/station/keyword/selectByKey',
    {
      keyword: value,
      limit: 10,
      siteTypeCode: 900800,
    },
    { reqType: null, module: 'mdp-station-keyword' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
  return [];
}

/**
 * 通过网点分拨code 获取对应信息
 * @return 返回完整营运区信息
 */
export async function getOperatingCenter(code) {
  const data = await crudRequest(
    '/api/station/organization/getByCode',
    { siteCode: code },
    { module: 'mdp-station-organization', reqType: null },
  );
  if (data?.code === 1) {
    return data.data;
  }
  return [];
}

/**
 * 获取营运区下级分拨
 * @returns
 */
export async function getOperatingAreaChildCenter(code) {
  const data = await crudRequest(
    '/api/station/business/selectList',
    {
      code,
      siteTypeCode: ['900100', '900200'],
      type: 'provinceArea',
    },
    { module: 'mdp-station-business' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
}

/**
 * 查询当前登录人 UAP 所属营运区（YSFNZ-8695 UAP 所属组织判断逻辑调整）
 * @returns {Promise<String[]>} 营运区 code 列表；无所属营运区时 data.provinceAreaCodeList 为空
 */
export async function getUapProvinceAreaCodes() {
  const data = await crudRequestGet('/api/route/checkPermission');
  if (data?.code === 1 && Array.isArray(data.data?.provinceAreaCodeList)) {
    return data.data.provinceAreaCodeList;
  }
  return [];
}

/**
 *  获取多个营运区下级分拨
 * @param {[String]} codes
 * @returns
 */
export async function getOperatingAreasChildCenter(codes) {
  const data = await crudRequest(
    '/api/station/business/batch/selectList',
    {
      codes: codes,
      siteTypeCode: ['900100', '900200'],
      type: 'provinceArea',
    },
    { module: 'mdp-station-business' },
  );
  if (data?.code === 1 && data.data?.length > 0) {
    return data.data;
  }
}

/**
 *
 * @param {*} siteNames 需要查询分拨的集合
 * @returns 查询分拨的所属营运区信息集合 @type <Map>
 */
export async function getBelongCenterForOperatingArea(siteNames) {
  const data = await crudRequest('/api/station/organization/selectByNames', siteNames, {
    module: 'mdp-station-organization',
  });
  const dataList = Object.values(data?.data);
  if (data?.code === 1 && dataList.length > 0) {
    const result = new Map();
    dataList.forEach((item) => result.set(item.siteName, item.siteOperateVo));
    return result;
  }
}

export async function GetTableDate(params) {
  const data = await crudRequest(`/api/route/od/provinceCargoVolumeMatrix/select`, params, {
    method: 'POST',
    reqType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (data && data.code === 1) {
    return data.data;
  }
  return [];
}
